"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.formatSeasonYear = formatSeasonYear;
exports.formatMonthYear = formatMonthYear;

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _uiwidgetsCommon = require("uiwidgets-common");

var _DateFormat = require("./DateFormat");

var _DateFormat2 = _interopRequireDefault(_DateFormat);

var _Seasons = require("./Seasons");

var _format = require("./format");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Format the fuzzy value as a season/year date. The format of the year is derived from the `format`
 * property on the DatePickerCtrl controller.
 *
 * @param value {Object} the date value to format.
 * @param format {String} the date format.
 * @param opts {Object} configuration object.
 *   @param opts.lang {String} the BCP-47 language code, defaults to "en".
 *   @param opts.seasonType {String} 'astronomical' or 'meteorological' (default).
 */
function formatSeasonYear(value, format, opts) {
    var lang = opts.lang || "en";
    var meteorological = opts.seasonType !== "astronomical";
    var seasonKey = (0, _Seasons.deriveSeason)(value, meteorological);
    var season = _Seasons.SEASONS[lang][seasonKey];

    // if there are multiple labels for season, use the first one as preference.
    Array.isArray(season) && (season = season[0]);

    // format up the `year` component of the date.
    var yearFormat = format.match(/[^yY]*([yY]+)/);
    var year = (0, _moment2.default)(value.start).format(yearFormat[1]);

    return season + " " + year;
};

/**
 * Format the fuzzy value as a month/year date. This format of the month/year is derived from the `format`
 * property on the DatePickerCtrl controller.
 *
 * @param value {Object} the date value to format.
 * @param format {String} the date format.
 * @param opts {Object} configuration object.
 */
function formatMonthYear(value, format, opts) {
    var monthFormat = format.match(/[^M]*(M+)/),
        yearFormat = format.match(/[^yY]*([yY]+)/),
        format = monthFormat[1] + " " + yearFormat[1],
        monthYear = (0, _moment2.default)(value.start).format(format);

    return monthYear;
}

exports.default = function (value, format, opts) {
    if (!value) {
        return null;
    }

    format || (format = _format.DEFAULT_DATE_FORMAT);
    opts || (opts = {});

    // if a "type" has not been provided, try to derive one.
    if (!value.type) {
        if (value.start || value.end) {
            // if we have a "start" and/or "end", make sure they're Date objects.
            (0, _uiwidgetsCommon.isString)(value.start) && (value.start = new Date(value.start));
            (0, _uiwidgetsCommon.isString)(value.end) && (value.end = new Date(value.end));

            // take a copy of the "value" object, adding in a default type of "date".
            value = _extends({ type: "date" }, value);
        }
    }

    switch (value.type) {
        case "date":
            return (0, _DateFormat2.default)(value.start || value.end, format, opts);
        case "month/year":
            return formatMonthYear(value, format);
        case "season/year":
            return formatSeasonYear(value, format, opts);
    }

    return null;
};
//# sourceMappingURL=DateFormatFuzzy.js.map